import { Card } from "@/components/ui/card";
import { MarketSegmentationSection } from "./market-sections/MarketSegmentationSection";
import { MarketSizeSection } from "./market-sections/MarketSizeSection";
import { MarketAccessibilitySection } from "./market-sections/MarketAccessibilitySection";

interface MarketAnalysisInputsProps {
  marketSegment: string;
  setMarketSegment: (value: string) => void;
  targetCustomerType: string;
  setTargetCustomerType: (value: string) => void;
  potentialCustomers: string;
  setPotentialCustomers: (value: string) => void;
  revenuePerCustomer: string;
  setRevenuePerCustomer: (value: string) => void;
  marketAccessibility: string;
  setMarketAccessibility: (value: string) => void;
  accessibilityLimitations: string[];
  setAccessibilityLimitations: (value: string[]) => void;
  marketPenetration: string;
  setMarketPenetration: (value: string) => void;
  customerAcquisitionRate: string;
  setCustomerAcquisitionRate: (value: string) => void;
  penetrationStrategies: string[];
  setPenetrationStrategies: (value: string[]) => void;
  marketValidation: string;
  setMarketValidation: (value: string) => void;
  benchmarkRequested: boolean;
  setBenchmarkRequested: (value: boolean) => void;
  churnRate: string;
  setChurnRate: (value: string) => void;
  customerLTV: string;
  setCustomerLTV: (value: string) => void;
  customerCAC: string;
  setCustomerCAC: (value: string) => void;
}

export const MarketAnalysisInputs = ({
  marketSegment,
  setMarketSegment,
  targetCustomerType,
  setTargetCustomerType,
  potentialCustomers,
  setPotentialCustomers,
  revenuePerCustomer,
  setRevenuePerCustomer,
  marketAccessibility,
  setMarketAccessibility,
  accessibilityLimitations,
  setAccessibilityLimitations,
  ...props
}: MarketAnalysisInputsProps) => {
  return (
    <div className="space-y-6">
      <Card className="p-4">
        <h3 className="text-lg font-semibold mb-4">Market Segmentation</h3>
        <MarketSegmentationSection
          marketSegment={marketSegment}
          setMarketSegment={setMarketSegment}
          targetCustomerType={targetCustomerType}
          setTargetCustomerType={setTargetCustomerType}
        />
      </Card>

      <Card className="p-4">
        <h3 className="text-lg font-semibold mb-4">Market Size Parameters</h3>
        <MarketSizeSection
          potentialCustomers={potentialCustomers}
          setPotentialCustomers={setPotentialCustomers}
          revenuePerCustomer={revenuePerCustomer}
          setRevenuePerCustomer={setRevenuePerCustomer}
        />
      </Card>

      <Card className="p-4">
        <h3 className="text-lg font-semibold mb-4">Market Accessibility</h3>
        <MarketAccessibilitySection
          marketAccessibility={marketAccessibility}
          setMarketAccessibility={setMarketAccessibility}
          accessibilityLimitations={accessibilityLimitations}
          setAccessibilityLimitations={setAccessibilityLimitations}
        />
      </Card>
    </div>
  );
};